import { all } from 'async-saga';
import { routerActions } from 'connected-react-router';
import { actions } from '..';
import { addParticipant, createConversation, getInstantMessagers, getOneOnOneConversation, hideConversation, joinConversation, leaveConversation, removeParticipant, sendMessage, sendParticipantInvite, setConversationAsRead, setConversationTitle, getInstantMessager } from '../../api/instantmessage-control';
import { saveInstantMessageSettings } from '../../api/options-control';
import { EntityType, InstantMessagerJoinState, InstantMessagerParticipantEndpointScheme, IsQueueConversation } from '../../model';
import { getConfig, selectConfigProp, selectMyself } from '../reducers/config';
import { getInstantMessageById, getInstantMessageUrgent, selectInstantMessagerJoined, getInstantMessageLoaded } from '../reducers/instantmessager';
import { selectMyMedia } from '../reducers/media';
import { takeEvery, waitForState } from '../tools/async-saga-types';
import { getCommandById } from '../reducers/command';

const instantMessagerSettingsSet = takeEvery(actions.instantMessagerSettingsSet, async function (ctx, { imEnabled, imAllowBlockedMessagesSentAsEmails, imBlockMessageInLocation }) {
  const myself = selectMyself(ctx.getState())
  if (!myself) { return }

  //save setting
  await saveInstantMessageSettings(myself, imEnabled, imAllowBlockedMessagesSentAsEmails, imBlockMessageInLocation)
  //update store
  ctx.dispatch(actions.instantMessagerSettingsUpdate(imEnabled, imAllowBlockedMessagesSentAsEmails, imBlockMessageInLocation))

})

const instantMessagerDataRequest = takeEvery(actions.instantMessagerDataRequest, async function (ctx) {
  const myself = selectMyself(ctx.getState())
  const socketId = selectConfigProp(ctx.getState(), 'socketId')
  if (!myself || !socketId) { return }

  //get data
  const data = await getInstantMessagers(myself, socketId)
  //update store
  ctx.dispatch(actions.instantMessagerDataResponse(data))
})

const requestLeaveConversation = takeEvery(actions.requestLeaveConversation, async function (ctx, conversationId) {
  const config = getConfig(ctx.getState())
  const conversation = getInstantMessageById(ctx.getState(), conversationId)

  if (!config || !conversation || conversation.joined === InstantMessagerJoinState.none) { return }

  await waitForState(ctx, s => selectInstantMessagerJoined(s, conversationId))

  ctx.dispatch(actions.setInstantMessagerJoinConversation(conversationId, InstantMessagerJoinState.none))

  setConversationAsRead(config, conversationId)
  leaveConversation(config, conversationId)
})

const joinQueuedInstantmessage = takeEvery(actions.joinQueuedInstantmessage, async function (ctx, { conversationId }) {
  const myself = selectMyself(ctx.getState())
  const config = getConfig(ctx.getState())
  const cache = getInstantMessageLoaded(ctx.getState())
  const command = getCommandById(ctx.getState(), conversationId)
  const agentName = !command || command.ExtendedInfo.PPInitialise === undefined ? 'Queue Agent' : command.ExtendedInfo.PPInitialise.AgentDisplayName

  if (!config || !myself || !config.socketId) { return }

  if (!cache) {
    await ctx.dispatch(actions.instantMessagerDataRequest(myself, config.socketId))
  }

  const conversation = getInstantMessageById(ctx.getState(), conversationId)
  if (!conversation) {

    //join conversation
    ctx.dispatch(actions.setInstantMessagerJoinConversation(conversationId, InstantMessagerJoinState.joining, true))
    //send join request
    await joinConversation(config, conversationId, 'queue-' + conversationId, agentName)
    //wait for join state
    await waitForState(ctx, s => selectInstantMessagerJoined(s, conversationId))

  } else {

    if (conversation.joined === InstantMessagerJoinState.none) {
      //join conversation
      ctx.dispatch(actions.setInstantMessagerJoinConversation(conversationId, InstantMessagerJoinState.joining))
      //send join request
      await joinConversation(config, conversationId)
      //wait for join state
      await waitForState(ctx, s => selectInstantMessagerJoined(s, conversationId))
    }

  }
})

const changeInstantmessageView = takeEvery(actions.changeInstantmessageView, async function (ctx, conversationId) {
  const myself = selectMyself(ctx.getState())
  const cache = getInstantMessageLoaded(ctx.getState())
  const config = getConfig(ctx.getState())
  const media = selectMyMedia(ctx.getState())
  const queued = (media.findIndex(_ => _.mediaItemId.toLocaleLowerCase() === conversationId.toLocaleLowerCase()) !== -1)
  let conversation = getInstantMessageById(ctx.getState(), conversationId)
  const isQueueConversation = conversation && IsQueueConversation(conversation)
  if (!config || !myself || !config.socketId || queued || isQueueConversation) { return }

  if (!conversation) {
    //get all data
    await ctx.dispatch(actions.instantMessagerDataRequest(myself, config.socketId))
    // wait for it to be loaded
    await waitForState(ctx, s => getInstantMessageById(s, conversationId) !== undefined)
    //get the conversation
    conversation = getInstantMessageById(ctx.getState(), conversationId)
  } else if (!cache) {
    //ctx.dispatch(actions.instantMessagerDataRequest(myself, config.socketId))
  }

  //should have the conversation
  if (conversation) {
    console.info('conversation ' + conversation.conversationId + ' ' + conversation.joined)
    //loaded from searh of recent
    if (conversation.userData === "search") {
      //conversation is already joined do not need to do anything
      ctx.dispatch(actions.setInstantMessagerJoinConversation(conversationId, InstantMessagerJoinState.joined))

    } else if (conversation.joined === InstantMessagerJoinState.none) {
      //join conversation
      ctx.dispatch(actions.setInstantMessagerJoinConversation(conversationId, InstantMessagerJoinState.joining))
      //send join request
      await joinConversation(config, conversationId, conversation.userData)
      //wait for join state
      await waitForState(ctx, s => selectInstantMessagerJoined(s, conversationId))
    }
  } else {
    console.error('Conversation should be here')
  }

  //view conversation if not attached to some media and loaded from search/recent i.e. user data = search
  if ((!queued || !isQueueConversation) && conversation && conversation.userData !== 'search') {
    ctx.dispatch(actions.setInstantmessageView(conversationId))
    ctx.dispatch(routerActions.replace('/chat'))
  }
})

const instantMessagerMessageSend = takeEvery(actions.instantMessagerMessageSend, async function (ctx, { conversationId, message }) {
  const urgent = getInstantMessageUrgent(ctx.getState())
  const socketId = selectConfigProp(ctx.getState(), 'socketId')
  if (!socketId) return

  let data = message.replace(/<p>&nbsp;<\/p>/g, "").trim();
  if (data.indexOf("<p>") === 0) {
    data = data.substring(3);
    data = data.substring(0, data.length - 4);
  }

  //response is a error message 
  const x = await sendMessage(conversationId, data, urgent, socketId)
  if (x !== '')
    ctx.dispatch(actions.instantMessagerMessageAdd(conversationId, '', '<div class="error">' + x + '</div>'))
  ctx.dispatch(actions.setInstantMessageUrgent(false))
})

const requestParticipantInvite = takeEvery(actions.requestParticipantInvite, async function (ctx, { conversationId, participantId }) {
  const config = getConfig(ctx.getState())
  if (!config) return

  await sendParticipantInvite(config, conversationId, participantId)
})

const requestOneOnOneConversation = takeEvery(actions.requestOneOnOneConversation, async function (ctx, { entity, type }) {
  const config = getConfig(ctx.getState())
  if (!config) return

  await getOneOnOneConversation(config, { endpointScheme: type === EntityType.Extension ? InstantMessagerParticipantEndpointScheme.IpfxExtension : type === EntityType.Contact ? InstantMessagerParticipantEndpointScheme.IpfxContact : InstantMessagerParticipantEndpointScheme.IpfxEmailContact, endpointServer: entity.server, endpointDeviceId: entity.id })
})

const requestRemoveParticipant = takeEvery(actions.requestRemoveParticipant, async function (ctx, { conversationId, participantId }) {
  const config = getConfig(ctx.getState())
  const conversation = getInstantMessageById(ctx.getState(), conversationId)
  if (!config || !conversation || !conversation.currentUserId) return

  await removeParticipant(config, conversationId, participantId, conversation.currentUserId)

})

const requestSetConversationTitle = takeEvery(actions.requestSetConversationTitle, async function (ctx, { conversationId, title }) {
  const config = getConfig(ctx.getState())
  const conversation = getInstantMessageById(ctx.getState(), conversationId)
  if (!config || !conversation) return

  await setConversationTitle(config, conversationId, title)
})

const requestImAddConversation = takeEvery(actions.requestImAddConversation, async function (ctx, { conversationId, endPoint }) {
  const config = getConfig(ctx.getState())
  const conversation = getInstantMessageById(ctx.getState(), conversationId)
  if (!config || !conversation) return

  await addParticipant(config, conversationId, endPoint)

})

const requestNewConversation = takeEvery(actions.requestNewConversation, async function (ctx) {
  const config = getConfig(ctx.getState())
  if (!config) return

  createConversation(config)
})

const hideInstantmessage = takeEvery(actions.hideInstantmessage, async function (ctx, payload) {
  const conversation = getInstantMessageById(ctx.getState(), payload)
  const socketId = selectConfigProp(ctx.getState(), 'socketId')
  if (!conversation || !socketId) return

  hideConversation(payload, socketId)
})

const fetchInstantMessageReadRequest = takeEvery(actions.fetchInstantMessageReadRequest, async function (ctx, { conversationId }) {
  const conversation = getInstantMessageById(ctx.getState(), conversationId)
  const socketId = selectConfigProp(ctx.getState(), 'socketId')
  if (conversation || !socketId) return

  getInstantMessager(conversationId, socketId)
})

const removeMediaItem = takeEvery(actions.removeMediaItem, async function (ctx, id) {
  const conversation = getInstantMessageById(ctx.prevState, id)
  const config = getConfig(ctx.getState())
  //if (!config || !conversation || !IsQueueConversation(conversation)) return
  if (!config || !conversation) return
  // essentially doing actions.requestLeaveConversation without all the checks. This is because that the conversation can already be removed already.
  // setConversationAsRead(config, id)
  leaveConversation(config, id, true);
})

export default all(
  instantMessagerSettingsSet,
  instantMessagerDataRequest,
  changeInstantmessageView,
  instantMessagerMessageSend,
  requestParticipantInvite,
  requestOneOnOneConversation,
  requestRemoveParticipant,
  requestLeaveConversation,
  requestSetConversationTitle,
  requestImAddConversation,
  requestNewConversation,
  hideInstantmessage,
  joinQueuedInstantmessage,
  fetchInstantMessageReadRequest,
  removeMediaItem,
)
